export const percentageFormatter = (value) => {
  return Number.isInteger(value) ? value + "%" : value.toFixed(2) + "%";
};
